export async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, { credentials: 'include', headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) }, ...init });
  const body = await response.json() as { success: boolean; data?: T; error?: { message: string } };
  if (!response.ok || !body.success) throw new Error(body.error?.message ?? 'Não foi possível concluir a operação.');
  return body.data as T;
}
